import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home'
import RSVPList from '../views/RSVPList'

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/guest',
    component: RSVPList
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
